// extracted by mini-css-extract-plugin
export var downArrow = "_8s-0";
export var label = "_8s-1";
export var treatmentCard = "_8s-3";
export var upArrow = "_8s-2";